import { create } from 'zustand'

import { initialAssetTypeState } from './slices/assetType'
import { initialDatePublishedState } from './slices/datePublished'
import { initialDesignersState } from './slices/designers'
import { initialFileTypesState } from './slices/fileTypes'
import { initialKeywordState } from './slices/keyword'
import { initialLicensesState } from './slices/licenses'
import { initialMoreFiltersState } from './slices/moreFilters'
import { initialPolygonState } from './slices/polygon'
import { initialPricingState } from './slices/pricing'
import { initialQualityContentState } from './slices/qualityContent'
import { initialResultsState } from './slices/results'
import { initialSizeState } from './slices/size'
import { initialSortByState } from './slices/sortBy'
import { initialStylesState } from './slices/styles'
import { initialTagsState } from './slices/tags'
import { initialThreeDOnlyState } from './slices/threeDOnly'
import { initialThreeDPrintOnlyState } from './slices/threeDPrintOnly'

const initialState = {
  ...initialAssetTypeState,
  ...initialDatePublishedState,
  ...initialDesignersState,
  ...initialFileTypesState,
  ...initialKeywordState,
  ...initialLicensesState,
  ...initialMoreFiltersState,
  ...initialPolygonState,
  ...initialPricingState,
  ...initialQualityContentState,
  ...initialResultsState,
  ...initialSizeState,
  ...initialSortByState,
  ...initialStylesState,
  ...initialTagsState,
  ...initialThreeDOnlyState,
  ...initialThreeDPrintOnlyState,
}

// Pristine copy taken before any seeding ever mutates `initialState` - the reset baseline below.
const pristineState = { ...initialState }

// Filter defaults only - the pristine state minus the results slice. Popstate restore resets
// filters to whatever the restored URL encodes without blanking the currently rendered results
// (the follow-up fetch replaces them, usually straight from the react-query cache).
export const pristineFilterState = Object.fromEntries(
  Object.entries(pristineState).filter(([key]) => !(key in initialResultsState))
)

export const useSearchPageStore = create(() => initialState)

export const searchPageStore = useSearchPageStore

// zustand v5 serves `getInitialState()` - the object captured at create() time - as the
// useSyncExternalStore SERVER snapshot, so a plain setState() seed is invisible to SSR
// (the server renders the pre-seed defaults). Seeding therefore updates both the captured
// initial state (read by the server render and the first hydration pass) and the live state.
// It also resets every key to its pristine default first: the SSR runtime reuses one JS context
// across requests, so without the reset a filter seeded by a previous request (e.g. ?sale_off=1)
// would leak into later renders that omit it - and fast-page caching could persist that HTML.
export const seedSearchPageStore = (partial) => {
  const seeded = { ...pristineState, ...partial }
  Object.assign(initialState, seeded)
  searchPageStore.setState(seeded)
}
